/*
  Samurai Home header behaviour
  - rotating top bar messages
  - see-through on the homepage hero, solid white after scrolling or while a menu is open
  - mega menus on hover (desktop) and keyboard
  - keeps --header-height up to date for the theme's other sections
*/
(function () {
  'use strict';

  function init(root) {
    var header = root.querySelector('[data-sh-header]');
    if (!header || header.__shInit) return;
    header.__shInit = true;

    var section = header.closest('.shopify-section') || header.parentElement;
    var top = header.querySelector('[data-sh-top]');
    var main = header.querySelector('[data-sh-main]');
    var transparent = header.classList.contains('sh-hdr--transparent');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* sizes the rest of the theme relies on */
    function measure() {
      var topH = top ? top.offsetHeight : 0;
      var mainH = main.offsetHeight;
      section.style.setProperty('--sh-top-h', topH + 'px');
      section.style.setProperty('--sh-main-h', mainH + 'px');
      document.documentElement.style.setProperty('--header-height', mainH + 'px');
      document.documentElement.style.setProperty('--sh-header-total', (topH + mainH) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);

    /* rotating messages */
    var msgBox = header.querySelector('[data-sh-msgs]');
    var msgs = msgBox ? msgBox.querySelectorAll('.sh-hdr__msg') : [];
    if (msgs.length > 1 && !reduce) {
      var i = 0;
      var every = (parseInt(msgBox.getAttribute('data-interval'), 10) || 5) * 1000;
      var timer = setInterval(next, every);
      msgBox.addEventListener('mouseenter', function () { clearInterval(timer); });
      msgBox.addEventListener('mouseleave', function () { clearInterval(timer); timer = setInterval(next, every); });
      function next() {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }
    }

    /* solid vs see-through */
    var openCount = 0;
    function updateSolid() {
      if (!transparent) return;
      var scrolled = window.scrollY > (top ? top.offsetHeight : 0) + 4;
      header.classList.toggle('is-solid', scrolled || openCount > 0);
    }
    window.addEventListener('scroll', updateSolid, { passive: true });
    updateSolid();

    /* mega menus */
    var items = header.querySelectorAll('[data-sh-mega-item]');
    var closeTimer = null;

    function setOpen(item, open) {
      var link = item.querySelector('.sh-hdr__nav-link');
      if (open === item.classList.contains('is-open')) return;
      item.classList.toggle('is-open', open);
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      openCount += open ? 1 : -1;
      header.classList.toggle('has-open', openCount > 0);
      updateSolid();
    }
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) setOpen(it, false); });
    }

    items.forEach(function (item) {
      var link = item.querySelector('.sh-hdr__nav-link');
      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { setOpen(item, false); }, 120);
      });
      // keyboard and touch: first activation opens the panel, second follows the link
      link.addEventListener('click', function (e) {
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          closeAll(item);
          setOpen(item, true);
        }
      });
      item.addEventListener('focusout', function () {
        setTimeout(function () { if (!item.contains(document.activeElement)) setOpen(item, false); }, 10);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = header.querySelector('[data-sh-mega-item].is-open');
      if (open) {
        setOpen(open, false);
        var l = open.querySelector('.sh-hdr__nav-link');
        if (l) l.focus();
      }
    });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(null); });
    var scrim = header.querySelector('[data-sh-scrim]');
    if (scrim) {
      scrim.addEventListener('click', function () { closeAll(null); });
      scrim.addEventListener('mouseenter', function () { closeTimer = setTimeout(function () { closeAll(null); }, 120); });
    }
  }

  function boot() { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
